import '../styles/HomePageSlideSection.css';

function HomeSlideSectionB() {
    return (
        <div className="main_container container-xxl slide d-flex justify-content-around align-items-center">
            <div className="slide__infob col-5">
                <h2>Apoyamos, orientamos & acompañamos</h2>
                <p>Apoyamos, orientamos y acompañamos a las familias ante el infortunado fallecimiento de su ser querido, dando un trato digno, respetuoso y profesional ante el duelo.</p>
            </div>

            <div className="image__containerb">
                <img src="./img/homeSliderSection/SectionB.avif" alt="Funeral home somos todos" />
            </div>
        </div>
    )
}

export default HomeSlideSectionB
